import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Route, Routes, useLocation } from "react-router";
import Fontstyling, { clientListDrpDwnStyles } from "../../../components/common/comman";
import CustomButton from "../../../components/common/CustomButton";
import {
  selectedClientData,
  clearClientData,
} from "../../../Redux/Reducer/ClientDataReducer";
import PlanAVDeviation from "./PlanAVDeviation";
import LargeClaimUW from "./LargeClaimUW";
import COBRAParticipation from "./COBRAParticipation";
import ClientLargeClaim from "./ClientLargeClaim";
import ClientWellnessProgram from "./ClientWellnessProgram";
import ClientDetail from "./ClientDetail";
import ClientRubs from "./ClientRubs";
import ImportCensus from "./Import Census";
import ClientList from "../../../components/common/ClientList";

const ClientData = ({ navigate }) => {
  const client = useSelector((state) => state.clientData.value);
  const [isEdit, setIsEdit] = useState(true);
  const [isAdd, setIsAdd] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [clientData, setClientData] = useState([]);
  const [selectedClientvalue, setSelectedClientValue] = useState(null);
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (client !== null && client?.clientID !== 0) {
      setSelectedClientValue({
        value: client?.clientID,
        label: client?.clientName,
      });
    } else {
      setSelectedClientValue({
        value: 0,
        label: "SELECT CLIENT NAME",
      });
      setShowForm(false);
    }
    setIsEdit(true);
    setIsAdd(true);
  }, [client, location.pathname]);

  const handleClientChange = (option) => {
    setSelectedClientValue(option);
    setShowForm(false);
    setIsEdit(true);
    setIsAdd(true);
    let clientobj = clientData.find((item) => item.clientID === option.value);
    dispatch(selectedClientData(clientobj));
  };

  return (
    <>
      <div className="d-md-flex d-block align-items-center justify-content-between py-3 border-bottom mb-3">
        <div className="d-flex gap-3">
          <ClientList
            clientData={clientData}
            setClientData={setClientData}
            customStyles={{
              ...clientListDrpDwnStyles,
              control: (base) => ({
                ...clientListDrpDwnStyles.control(base),
                width: "330px",
                border: "1px solid grey",
                maxHeight: "35px",
                height: "35px",
              }),
            }}
            handleClientChange={handleClientChange}
            selectedClientvalue={selectedClientvalue}
            setSelectedClientValue={setSelectedClientValue}
          />
        </div>

        {(location.pathname.endsWith("clientdetail") ||
          location.pathname.endsWith("clientdata")) && (

            <div className="d-flex align-items-center">
              <>
                {isAdd && isEdit &&<CustomButton
                  style={{
                    ...Fontstyling.addnewbutton,
                  }}
                  onClick={() => {
                    setIsAdd(false);
                    setShowForm(false);
                    setSelectedClientValue({
                      value: 0,
                      label: "SELECT CLIENT NAME",
                    });
                  }}
                >
                  Add Prospect
                </CustomButton>
              }
            </>
            {isEdit && isAdd && (
              <>
                {client && client?.clientID ? (
                  <>
                    <CustomButton
                      style={{
                        ...Fontstyling.addnewbutton,
                      }}
                      onClick={() => {
                        setIsEdit(false);
                      }}
                    >
                      Edit
                    </CustomButton>
                  </>
                ) : null}
              </>
            )}
          </div>
        )}
      </div>
      <Routes>
        <Route
          index
          element={
            <ClientDetail
              showForm={showForm}
              setShowForm={setShowForm}
              isEdit={isEdit}
              setIsEdit={setIsEdit}
              isAdd={isAdd}
              setIsAdd={setIsAdd}
              setSelectedClientValue={setSelectedClientValue}
            />
          }
        />
        <Route
          path="/clientdetail"
          element={
            <ClientDetail
              showForm={showForm}
              setShowForm={setShowForm}
              isEdit={isEdit}
              setIsEdit={setIsEdit}
              isAdd={isAdd}
              setIsAdd={setIsAdd}
              setSelectedClientValue={setSelectedClientValue}
            />
          }
        />
        <Route
          path="/largeclaimuw"
          element={<LargeClaimUW navigate={navigate} />}
        />
        <Route
          path="/cobrapartipation"
          element={<COBRAParticipation navigate={navigate} />}
        />
        <Route
          path="/clientlargeclaim"
          element={<ClientLargeClaim navigate={navigate} />}
        />
        <Route
          path="/wellnessprograms"
          element={<ClientWellnessProgram navigate={navigate} />}
        />
        <Route path="/census" element={<ImportCensus navigate={navigate} />} />
        <Route
          path="planavdeviation"
          element={<PlanAVDeviation navigate={navigate} />}
        />
       
      </Routes>
    </>
  );
};

export default ClientData;
